import produce from 'immer';
import { Reducer } from 'redux';
import _ from 'lodash';

import { CoachState, CoachTypes } from '../types';

const initialState: CoachState = {
    isLoading: false,
    coach: [],
};

const coachReducer: Reducer<CoachState> = (state = initialState, action) => {
    return produce(state, (draft) => {
        switch (action.type) {
            case CoachTypes.ADD_COACH_INFO: {
                draft.isLoading = false;
                draft.error = undefined;
                if (draft.coach.some((c) => c.uid == action.payload.uid)) {
                    draft.coach = _.map(draft.coach, (user) => {
                        return user.uid === action.payload.uid
                            ? {
                                  ...user,
                                  description: action.payload.description,
                                  image: action.payload.image,
                                  phoneNumber: action.payload.phoneNumber,
                              }
                            : user;
                    });
                } else {
                    draft.coach = [...draft.coach, action.payload];
                }
                break;
            }
            case CoachTypes.GET_LIST_COACH: {
                draft.isLoading = false;
                draft.error = undefined;
                draft.coach = action.payload.coach;
                break;
            }
            case CoachTypes.UPDATE_COACH_AVAILABLE_TIME: {
                draft.isLoading = false;
                draft.error = undefined;
                draft.coach = state.coach.map((coach) => {
                    if (coach.uid === action.payload.coachId) {
                        return { ...coach, availableTime: action.payload.availableTime };
                    }
                    return coach;
                });
                break;
            }
            case CoachTypes.REQUEST_GET_LIST_COACH: {
                draft.isLoading = true;
                draft.error = undefined;
                break;
            }
            case CoachTypes.COACH_ERROR: {
                draft.isLoading = false;
                draft.error = action.payload.error;
                break;
            }
            case CoachTypes.CLEAR_COACH_ERROR: {
                draft.error = undefined;
                break;
            }
            default: {
                return draft;
            }
        }
    });
};

export { coachReducer };
